import getQueryParamsFromStringObjectUtil from 'utils/object/get-query-params-from-string'

export default function getProductIdFromUrlProductUtil () {
  return getQueryParamsFromStringObjectUtil().product_id
}
